import React from 'react';
import { Section } from './ui/Section';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  return <Section background="white" data-id="element-300">
      <div className="text-center mb-16" data-id="element-301">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-stone-900 mb-4" data-id="element-302">
          Ellas ya dominaron el arte
        </h2>
        <div className="flex justify-center gap-1" data-id="element-303">
          {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 fill-amber-500 text-amber-500" data-id="element-304" />)}
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-305">
        <div className="bg-stone-50 p-8 rounded-xl border border-stone-100 relative" data-id="element-306">
          <div className="absolute -top-4 -left-4 text-6xl text-amber-200 font-serif leading-none" data-id="element-307">
            "
          </div>
          <p className="text-stone-700 text-lg italic mb-6 relative z-10" data-id="element-308">
            Vivo en Miami y la humedad siempre arruinaba mis postres. Hice el
            Mil Hojas para el cumpleaños de mi suegra y{' '}
            <span className="font-bold text-stone-900" data-id="element-309">
              se mantuvo crujiente por 2 días
            </span>
            . ¡No lo podía creer!
          </p>
          <div className="flex items-center gap-4" data-id="element-310">
            <div className="w-12 h-12 bg-amber-200 rounded-full flex items-center justify-center text-amber-800 font-bold text-lg" data-id="element-311">
              C
            </div>
            <div data-id="element-312">
              <p className="font-bold text-stone-900" data-id="element-313">Carolina M.</p>
              <p className="text-sm text-stone-500" data-id="element-314">Miami, FL</p>
            </div>
          </div>
        </div>

        <div className="bg-stone-50 p-8 rounded-xl border border-stone-100 relative" data-id="element-315">
          <div className="absolute -top-4 -left-4 text-6xl text-amber-200 font-serif leading-none" data-id="element-316">
            "
          </div>
          <p className="text-stone-700 text-lg italic mb-6 relative z-10" data-id="element-317">
            Siempre me daba vergüenza llevar postres porque llegaban feos. Con
            esta técnica, el corte salió perfecto.{' '}
            <span className="font-bold text-stone-900" data-id="element-318">
              Mis amigas pensaron que lo compré en una pastelería francesa.
            </span>
          </p>
          <div className="flex items-center gap-4" data-id="element-319">
            <div className="w-12 h-12 bg-amber-200 rounded-full flex items-center justify-center text-amber-800 font-bold text-lg" data-id="element-320">
              S
            </div>
            <div data-id="element-321">
              <p className="font-bold text-stone-900" data-id="element-322">Sofia R.</p>
              <p className="text-sm text-stone-500" data-id="element-323">Houston, TX</p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}